<template>
  <div class="youth-list-view">
    <div v-if="seasonType.youthPlayer">
      <div class="tab-box">
        <ul class="tab-btn-list match">
          <li v-for="(tab, index) in tabList" :key="index" :class="{active:currentTab === index}"
              @click="tabIndexChange(currentTab)">
            <a href="#" @click.prevent="currentTab = index">{{ tab }}</a>
          </li>
        </ul>
      </div>
      <div v-if="currentTab === 0" class="tab-content">
        <YouthPlayerList :route-name="routeName" />
      </div>
      <div v-if="currentTab === 1" class="tab-content">
        <YouthStaffList :route-name="routeName" />
      </div>
    </div>
    <div v-else>
      <PageComingSoon :titleText="' '" :descriptionText="String(seasonMsg)" />
    </div>
  </div>
</template>

<script>

import YouthPlayerList from '@/components/Youth/YouthPlayerList.vue';
import YouthStaffList from '@/components/Youth/YouthStaffList.vue';
import PageComingSoon from '@/components/Common/PageComingSoon.vue';

export default {
  name: 'YouthListView',
  components: {PageComingSoon, YouthStaffList, YouthPlayerList},
  data() {
    return {
      currentTab: 0,
      tabList: ['선수소개', '코칭스태프'],
      seasonType: this.$store.getters['getSeasonType'],
      seasonMsg: this.$store.getters['getSeasonMsg'],
    }
  },
  mounted () {
    this.currentTab = 0;
  },
  methods: {
    tabIndexChange(val) {
    },
  },
  watch: {
    routeName: {
      handler: function () {
        this.currentTab = 0;
      }
    }
  },
  computed: {
    routeName() {
      return this.$route.name;
    }
  },
}
</script>
